export default __webpack_public_path__ + "static/media/demo-1.48d3393a.jpg";